export enum PreCheckinCountriesNationalitiesActionTypes {
  IsPreCheckinCountriesNationalitiesReady = '[IsPreCheckinCountriesNationalitiesReady] action',
  GetCountries = '[GetCountries] action',
  GetNationalities = '[GetNationalities] action'
}

export class IsPreCheckinCountriesNationalitiesReady {
  public static readonly type =
    PreCheckinCountriesNationalitiesActionTypes.IsPreCheckinCountriesNationalitiesReady;

  constructor(public isPreCheckinCountriesNationalitiesReady: boolean) {}
}

export class GetCountries {
  public static readonly type =
    PreCheckinCountriesNationalitiesActionTypes.GetCountries;
}

export class GetNationalities {
  public static readonly type =
    PreCheckinCountriesNationalitiesActionTypes.GetNationalities;
}
